import React from 'react';
import { Formik } from 'formik';
import ServiceRequestStepContent from './ServiceRequestStepContent';

function ServiceRequestStep({ step, stepNumber, status, onStepSubmit, onGoToStep, values }) {
    const { title, validationSchema, activeChildren, inactiveChildren } = step;

    if (status === 'active') {
        return (
            <Formik
                onSubmit={onStepSubmit}
                initialValues={values}
                validationSchema={validationSchema}
                render={formikProps => {
                    const { values, submitForm, setFieldValue, handleBlur, touched, errors } = formikProps;
                    return (
                        <ServiceRequestStepContent
                            stepNumber={stepNumber}
                            title={title}
                            onGoToStep={onGoToStep}
                            status={status}
                            onSubmit={submitForm}
                        >
                            {activeChildren({ values, setFieldValue, handleBlur, touched, errors })}
                        </ServiceRequestStepContent>
                    );
                }}
            />
        );
    }

    return (
        <ServiceRequestStepContent stepNumber={stepNumber} title={title} onGoToStep={onGoToStep} status={status}>
            {inactiveChildren({ values })}
        </ServiceRequestStepContent>
    );
}

export default ServiceRequestStep;
